import { ButtonBase } from "@mui/material";
import { Popover } from "antd";
import { useState } from "react";

const BonusSwitchBox = (props) => {
  const { title, tabs, info, value } = props;
  const [tabIdx, setTabIdx] = useState(0);
  let tootipText = "coming soon";
  const handleSwitch = (tabId, idx) => {
    setTabIdx(idx);
    if (props.settingsHandle) {
      props.settingsHandle(idx, title.toLowerCase(), tabId);
    }
  };

  return (
    <div className={`switch_tab mr-[20px] mb-[15px] inline-block`}>
      <label className="text-[13px] text-[#878B91] mb-[10px] inline-flex items-center">
        {title && title}
        {info && (
          <Popover content={tootipText}>
            <img
              src="/images/fi_info.svg"
              alt="info"
              className="inline-block ml-[8px] cursor-pointer"
            />
          </Popover>
        )}
      </label>
      <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
        {tabs &&
          tabs.map((tab, idx) => {
            return (
              <ButtonBase key={idx}>
                <span
                  className={`switch ${value.toString() === tab?.val && "active"}`}
                  onClick={() => handleSwitch(tab?.val, idx)}
                >
                  {tab && tab.name}
                </span>
              </ButtonBase>
            );
          })}
      </div>
    </div>
  );
};

export default BonusSwitchBox;
